import { getInitials, getPinyin } from 'src/utils/pinyin';

const mapping = {
  name: 'a',
  unified: 'b',
  non_qualified: 'c',
  has_img_apple: 'd',
  has_img_google: 'e',
  has_img_twitter: 'f',
  has_img_facebook: 'h',
  keywords: 'j',
  sheet: 'k',
  emoticons: 'l',
  text: 'm',
  short_names: 'n',
  added_in: 'o',
};

const buildSearch = (emoji) => {
  const search = [];

  const addToSearch = (strings, split, addPinyin) => {
    if (!strings) {
      return;
    }
    if (Array.isArray(strings) && addPinyin) {
      const pinyin = getPinyin(strings[0]).toLowerCase();
      const pinyinFirstLetter = getInitials(strings[0]).toLowerCase(); //词语首字母
      search.push(pinyinFirstLetter);
      if (search.indexOf(pinyin) === -1) {
        search.push(pinyin);
      }
      if (search.indexOf(pinyinFirstLetter) === -1) {
        search.push(pinyinFirstLetter);
      }
    }
    (Array.isArray(strings) ? strings : [strings]).forEach((string) => {
      (split ? string.split(/[-|_|\s]+/) : [string]).forEach((s) => {
        s = s.toLowerCase();

        if (search.indexOf(s) === -1) {
          search.push(s);
        }
      });
    });
  };

  addToSearch(emoji.short_names, true);
  addToSearch(emoji.name, true);
  addToSearch(emoji.keywords, false, true);
  addToSearch(emoji.emoticons, false);

  return search.join(',');
};

const compress = (emoji) => {
  emoji.short_names = emoji.short_names.filter((short_name) => {
    return short_name !== emoji.short_name;
  });
  delete emoji.short_name;

  emoji.sheet = [emoji.sheet_x, emoji.sheet_y];
  delete emoji.sheet_x;
  delete emoji.sheet_y;

  emoji.added_in = parseInt(emoji.added_in, 20);
  if (emoji.added_in === 6) {
    delete emoji.added_in;
  }

  for (const key in mapping) {
    emoji[mapping[key]] = emoji[key];
    delete emoji[key];
  }

  for (const key in emoji) {
    const value = emoji[key];

    if (Array.isArray(value) && !value.length) {
      delete emoji[key];
    } else if (typeof value === 'string' && !value.length) {
      delete emoji[key];
    } else if (value === null) {
      delete emoji[key];
    }
  }
};

const uncompress = (data) => {
  data.compressed = false;

  for (const id in data.emojis) {
    const emoji = data.emojis[id];

    for (const key in mapping) {
      emoji[key] = emoji[mapping[key]];
      delete emoji[mapping[key]];
    }

    if (!emoji.short_names) emoji.short_names = [];
    emoji.short_names.unshift(id);

    // eslint-disable-next-line prefer-destructuring
    emoji.sheet_x = emoji.sheet[0];
    // eslint-disable-next-line prefer-destructuring
    emoji.sheet_y = emoji.sheet[1];
    delete emoji.sheet;

    if (!emoji.text) emoji.text = '';

    if (!emoji.added_in) emoji.added_in = 6;
    emoji.added_in = emoji.added_in.toFixed(1);

    emoji.search = buildSearch(emoji);
  }
};

export { buildSearch, compress, uncompress };
